// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from 'mergeI18nTranslations';

mergeI18nTranslations({"en-AU":{"disableWhileLoading":{"loading":"Loading..."}},"en-CA":{"disableWhileLoading":{"loading":"Loading..."}},"en-GB":{"disableWhileLoading":{"loading":"Loading..."}},"is":{"disableWhileLoading":{"loading":"Hleð inn..."}},"mi":{"disableWhileLoading":{"loading":"E Uta ana ...."}},"ru":{"disableWhileLoading":{"loading":"Выполняется загрузка..."}}});
